<script>
export default {
  name: "cars",
  props: {
    schedule: {
      type: Object,
      default: null
    },
  },
  computed: {
    getCars(){
      let cars = this.schedule.assigned_cars_by_schedule;
      let res = [];
      res = cars.map(function(car){
        return "["+car.hiragana + " " + car.number + "] " + car.name;
      });
      return res.join(" , ");
    }
  }
}
</script>

<template>
  <div v-if="getCars" v-html="getCars" class="content-area"></div>
</template>

<style scoped lang="scss">
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
